const TITLES = {
  danger: "Error",
  warning: "Warning",
  success: "Success",
  info: "Notice"
}

// Mirrors Rails' convention of mapping the `alert` flash key to "danger" styling.
const buildToastElement = function({ type, message }) {
  const resolvedType = type === "alert" ? "danger" : (type || "info")
  const title = TITLES[resolvedType] || "Notice"

  const toast = document.createElement("div")
  toast.className = `toast text-bg-${resolvedType} fade`
  toast.setAttribute("role", "alert")
  toast.setAttribute("aria-live", "assertive")
  toast.setAttribute("aria-atomic", "true")
  toast.setAttribute("data-controller", "flash")

  toast.innerHTML = `
    <div class="toast-header">
      <strong class="me-auto">${title}</strong>
      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
    <div class="toast-body"></div>
  `
  // textContent, not innerHTML: this message isn't sanitized like the server-rendered flash.
  toast.querySelector(".toast-body").textContent = message

  return toast
}

export { buildToastElement }
